import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { Herinnering } from "./pages/sections/Herinneringen";
import { Begrafenis } from "./pages/sections/Begrafenis";
import { Home } from "./pages/Home";
import { Erwin } from "./pages/sections/Erwin";
import { Gallerij } from "./pages/sections/Gallerij";
import { Toaster } from "react-hot-toast";

const theme = createTheme({
  typography: {
    fontFamily: `'Montserrat', sans-serif`,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        html, body {
          margin: 0;
          padding: 0;
        }
      `,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route index element={<Erwin />} />
            <Route path="herinnering" element={<Herinnering />} />
            <Route path="gallerij" element={<Gallerij />} />
            <Route path="begrafenis" element={<Begrafenis />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
